import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import LoginForm from '../../components/forms/login-form/login-form'
import styled from 'styled-components'

const LoginPageStyled = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    padding-top: 160px;
`

interface LoginPageProps {}

const LoginPage: FC<LoginPageProps> = () => {
    const navigate = useNavigate()

    const onSuccess = async () => {
        navigate('/')
    }

    return (
        <LoginPageStyled>
            <LoginForm onSuccess={onSuccess} />
        </LoginPageStyled>
    )
}

export default LoginPage
